import { useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import IconMarkUp from "../Icon-markup";
import IcoCommon from "./Common/IcoCommon";
import { ICO_ICONS } from "../../../Data/Icons";
import { Breadcrumbs } from "../../../AbstractElements";
import { IcoIcon, Icons } from "../../../Constant";

const IcoIconsContainer = () => {
  const [iTag, setiTag] = useState<string | object>("");
  const [icon, setIcon] = useState<string | object>("");

  const callback = useCallback((tag: string) => {
    setiTag({iTag: '<i className="icofont icofont-' + tag + '"></i>',});
    setIcon({icon: "icofont icofont-" + tag + " fa-2x",});}, []);

  return (
    <>
      <Breadcrumbs pageTitle={IcoIcon} parent={Icons} title={IcoIcon} />
      <Container fluid>
        {ICO_ICONS.map((data, index) => {
          return (
            <Row key={index}>
              <IcoCommon iconType={data.icons} title={data.tittle} parentCallback={callback}/>
            </Row>
          );
        })}
      </Container>
      <IconMarkUp itag={iTag} icons={icon} />
    </>
  );
};
export default IcoIconsContainer;
